import './faro';
import ReactDOM from 'react-dom/client';
import './index.css';
import { FaroErrorBoundary } from '@grafana/faro-react';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <FaroErrorBoundary>
        <Provider store={store}>
            <App />
        </Provider>
    </FaroErrorBoundary>
);
